/**
 * 产品模块路由
 * topNav: products
 */
export default {
  path: 'products',
  name: 'Products',
  component: () => import('@/layout/RouteView.vue'),
  meta: {
    title: '产品',
    titleKey: 'routes.products',
    topNav: 'products',
    icon: 'AppstoreOutlined',
  },
  children: [
    // 产品库（分组）
    {
      path: 'product-library',
      name: 'ProductLibrary',
      component: () => import('@/layout/RouteView.vue'),
      meta: { title: '产品库', titleKey: 'routes.productLibrary', icon: 'AppstoreOutlined' },
      children: [
        {
          path: 'list',
          name: 'ProductList',
          component: () => import('@/views/products/manage/list/index.vue'),
          meta: { title: '产品列表', titleKey: 'routes.productList', permission: 'products:list' },
        },
        {
          path: 'list/add',
          name: 'ProductAdd',
          component: () => import('@/views/products/manage/list/addEdit.vue'),
          meta: {
            title: '添加产品',
            titleKey: 'routes.productAdd',
            hidden: true,
            permission: 'products:create',
          },
        },
        {
          path: 'list/edit/:id',
          name: 'ProductEdit',
          component: () => import('@/views/products/manage/list/addEdit.vue'),
          meta: {
            title: '编辑产品',
            titleKey: 'routes.productEdit',
            hidden: true,
            permission: 'products:update',
          },
        },
        {
          path: 'category',
          name: 'ProductCategory',
          component: () => import('@/views/products/manage/categories/index.vue'),
          meta: {
            title: '产品分类',
            titleKey: 'routes.productCategory',
            permission: 'products:category',
          },
        },
        {
          path: 'attribute',
          name: 'ProductAttribute',
          component: () => import('@/views/products/manage/attributes/index.vue'),
          meta: {
            title: '产品属性',
            titleKey: 'routes.productAttribute',
            permission: 'products:attribute',
          },
        },
      ],
    },
    // 礼品库（分组）
    {
      path: 'gift-library',
      name: 'GiftLibrary',
      component: () => import('@/layout/RouteView.vue'),
      meta: { title: '礼品库', titleKey: 'routes.giftLibrary', icon: 'GiftOutlined' },
      children: [
        {
          path: 'list',
          name: 'GiftList',
          component: () => import('@/views/products/gifts/list/index.vue'),
          meta: { title: '礼品列表', titleKey: 'routes.giftList', permission: 'gift:list' },
        },
        {
          path: 'list/add',
          name: 'GiftAdd',
          component: () => import('@/views/products/gifts/list/addEdit.vue'),
          meta: {
            title: '添加礼品',
            titleKey: 'routes.giftAdd',
            hidden: true,
            permission: 'gift:create',
          },
        },
        {
          path: 'list/edit/:id',
          name: 'GiftEdit',
          component: () => import('@/views/products/gifts/list/addEdit.vue'),
          meta: {
            title: '编辑礼品',
            titleKey: 'routes.giftEdit',
            hidden: true,
            permission: 'gift:update',
          },
        },
        {
          path: 'category',
          name: 'GiftCategory',
          component: () => import('@/views/products/gifts/categories/index.vue'),
          meta: { title: '礼品分类', titleKey: 'routes.giftCategory', permission: 'gift:category' },
        },
      ],
    },
    // 生产信息（分组）
    {
      path: 'production-info',
      name: 'ProductionInfo',
      component: () => import('@/layout/RouteView.vue'),
      meta: { title: '生产信息', titleKey: 'routes.productionInfo', icon: 'ToolOutlined' },
      children: [
        {
          path: 'batch',
          name: 'ProductionBatch',
          component: () => import('@/views/products/production/batches/index.vue'),
          meta: {
            title: '生产批次',
            titleKey: 'routes.productionBatch',
            permission: 'production:batch',
          },
        },
        {
          path: 'batch/add',
          name: 'BatchAdd',
          component: () => import('@/views/products/production/batches/addEdit.vue'),
          meta: {
            title: '添加生产批次',
            titleKey: 'routes.batchAdd',
            hidden: true,
            permission: 'production:create',
          },
        },
        {
          path: 'batch/edit/:id',
          name: 'BatchEdit',
          component: () => import('@/views/products/production/batches/addEdit.vue'),
          meta: {
            title: '编辑生产批次',
            titleKey: 'routes.batchEdit',
            hidden: true,
            permission: 'production:update',
          },
        },
        {
          path: 'factory',
          name: 'FactoryManagement',
          component: () => import('@/views/products/production/factories/index.vue'),
          meta: {
            title: '工厂管理',
            titleKey: 'routes.factoryManagement',
            permission: 'production:factory',
          },
        },
      ],
    },
    // 素材库（直接页面，无子级）
    {
      path: 'material-library',
      name: 'MaterialLibrary',
      component: () => import('@/views/products/material/material-library.vue'),
      meta: {
        title: '素材库',
        titleKey: 'routes.materialLibrary',
        icon: 'FileImageOutlined',
        permission: 'products:material',
        contentPlain: true,
        contentFull: true,
      },
    },
  ],
};
